<template>
    <div class="component hours-split-table mt-50">
        <div class="row">
            <div class="col-12">
                <el-card class="box-card" v-loading="$store.state.cost.hoursSplitLoading">
                    <!-- <h4 class="title text-left" slot="header">Table</h4> -->
                    <el-table
                        :data="getData"
                        style="width: 100%"
                        :row-class-name="tableRowClassName"
                        :cell-style="cellStyling"
                        :cell-class-name="cellStyle"
                        :header-cell-class-name="cellStyle"
                        row-key='id'
                        @sort-change="sortChanged"
                        :tree-props=treeProps
                    >
                        <el-table-column  :prop=firstColMapping[$store.state.cost.hoursSplitSwitchValue]
                                          label=""
                                          :sortable=false
                                          :formatter="formatter">
                        </el-table-column>
                        <el-table-column v-for="topHeader of ['this_year', 'last_year']" :key="topHeader" :label="topHeader | formatVariableName">
                            <el-table-column  v-for="col in headers[topHeader]"
                                              :key="col.prop"
                                              :prop="col.prop"
                                              :label="col.name | formatVariableName"
                                              :sortable=true
                                              :formatter="formatter">
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import { formatString } from '@/functions'
export default {
    data () {
        return {
            loaded: false,
            treeProps: { children: 'children' },
            firstColMapping: { Month: 'year_month', Store: 'store_id', Employee: 'employee' }

        }
    },
    methods: {
        sortChanged (param) {
            const { prop, order } = param
            this.$store.commit('cost/SORT_CHILDS_HOURS_SPLIT', { 'prop': prop, 'order': order })
        },
        formatter (row, column) {
            if (column.property === 'employee') {
                return formatString(row[column.property])
            } else if (column.property.includes('year_month') === false && column.property.includes('store_id') === false && column.property.includes('score') === false) {
                return String(parseFloat((parseFloat(row[column.property]) * 100)).toLocaleString('en-EN', { minimumFractionDigits: 1, maximumFractionDigits: 1 })) + '%'
            } else if (row[column.property] !== null && row !== null && column.property !== null && row[column.property] !== undefined) {
                return row[column.property].toLocaleString('en-EN')
            }
        },
        tableRowClassName ({ row, rowIndex }) {
            if (row.weekday === 'total' || row.child === true) {
                return 'highlight-row'
            }
        },
        cellStyling (param) {
            const { column, row } = param
            if (column.property === 'score' && row[column.property] !== null) {
                if (row[column.property] < 90) {
                    return { backgroundColor: '#f5c6cb' }
                } else if (row[column.property] >= 110) {
                    return { backgroundColor: '#c3e6cb' }
                } else {
                    return { backgroundColor: 'rgba(0,0,0,.075)' }
                }
            }
        },
        cellStyle (param) {
            const { column } = param
            if (column.property !== undefined) {
                if (column.property.includes('worked')) {
                    return 'borderLeftThick'
                }
                if (column.property.includes('score')) {
                    return 'borderLeft'
                }
            } else {
                if (column.level === 1 && column.label !== undefined) {
                    return 'borderTopHeader'
                }
            }
        }
    },
    computed: {
        getData () {
            if (this.$store.state.cost.hoursSplitTable.length === 0) {
                return []
            } else {
                return this.$store.state.cost.hoursSplitTable
            }
        },
        headers () {
            if (this.$store.state.cost.hoursSplitTable.length === 0) {
                return []
            } else {
                let h = { 'this_year': [], 'last_year': [] }
                let c = Object.keys(this.$store.state.cost.hoursSplitTable[0])
                let idx = c.indexOf('children')
                c.splice(idx, 1)
                idx = c.indexOf('child')
                c.splice(idx, 1)
                idx = c.indexOf('id')
                c.splice(idx, 1)

                if (c.includes('year_month')) {
                    idx = c.indexOf('year_month')
                    c.splice(idx, 1)
                } else if (c.includes('store_id')) {
                    idx = c.indexOf('store_id')
                    c.splice(idx, 1)
                } else if (c.includes('employee')) {
                    idx = c.indexOf('employee')
                    c.splice(idx, 1)
                }

                for (let item of c) {
                    if (item !== 'score') {
                        if (item.includes('ly')) {
                            h['last_year'].push({ prop: item, name: item.replace('_ly', '') })
                        } else {
                            h['this_year'].push({ prop: item, name: item })
                        }
                    }
                }
                h['this_year'].push({ prop: 'score', name: 'score' })
                return h
            }
        }
    },
    created () {
        this.loading = false
    }
}
</script>
<style lang="scss">
.hours-split-table {
.el-table--border td {
    border-right: none;
}
.el-table--border th {
    border-right: none;
}
.el-table--border {
    border-left: none;
    border-top: none;
}
.el-table--border::after {
    width: 0pxMa;
}
.borderLeft {
    border-left: 1px solid #EBEEF5;
}
.borderLeftThick {
    border-left: 3px solid #EBEEF5;
}
th {
    background-color: #fff !important;
}
.borderTopHeader {
    border-bottom: none;
    border-top: none;
    border-left: 3px solid #EBEEF5;
}
}
</style>
